import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75db193a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "new-game-page" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  class: "error"
}

import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useGamesApi } from './GamesApi'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewGamePage',
  setup(__props) {

const gamesApi = useGamesApi()
const router = useRouter()

const creatingRef = ref(false)
const errorRef = ref('')

async function createGame() {
  creatingRef.value = true
  errorRef.value = ''
  try {
    const def = await gamesApi.createGame()
    await router.replace(`/games/${def.id}/design`)
  } catch (e) {
    errorRef.value = `Couldn't create the game: ${(e as Error).message}`
  } finally {
    creatingRef.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "btn btn-primary btn-lg",
      disabled: creatingRef.value,
      onClick: createGame
    }, _toDisplayString(creatingRef.value ? 'Creating…' : 'New game'), 9, _hoisted_2),
    (errorRef.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(errorRef.value), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})